"use strict";

import React from 'react';

import {
    classMixer, EventSource
  } from 'generics/utils';
import { IconGlyphicon } from 'generics/icons';


const dialogEvents = new EventSource();


let modalNonce = 0;


export class DialogHolder extends React.Component {
  constructor(props)  {
    super(props);

    this.state = {
      "stack":[]
    };
  }


  componentDidMount()  {
    dialogEvents.on("pushModal", this.pushComponent );
  }


  componentWillUnmount()  {
    dialogEvents.off("pushModal", this.pushComponent );
  }


  removeComponent(key)  {
    this.setState( (prevState, props) => {
      const stack = prevState.stack.filter(  (x) => (x.key != key)  );
      return {  stack  };
    });
  }


  pushComponent = ({ Modal, modalProps })  =>  {
    const key = ++modalNonce;

    const modalDesc = {
        key,
        Modal,
        modalProps: Object.assign({},modalProps,{
            key,
            removeModal: () => this.removeComponent(key),
            ref: ( r )  =>  {modalDesc.mounted = r;}
          }),
      };

    this.setState( (prevState, props) => ({  "stack": prevState.stack.concat(modalDesc)  }) );
  }


  onBackdropTouch = (event)  =>  {
    event.stopPropagation();

    const {  mounted  } = (this.state.stack.slice(-1)[0]  ||  {});
    mounted && mounted.onBackdropTouch();
  }


  render() {
    if ( this.state.stack.length == 0 )
      return null;

    return (
      <div  className="modal-backdrop-plate"  onClick={this.onBackdropTouch}  >
      { this.state.stack.map(
            ({ Modal, modalProps, key }) =>  <ModalHolderPlate key={key} Modal={Modal} modalProps={modalProps} />
          )}
      </div>
    );
  }
}


function onHolderPlateTouch(event)  {
  event.stopPropagation();
}


function ModalHolderPlate({  Modal, modalProps  }) {
  return  <div  className="modal-holder-plate"  onClick={onHolderPlateTouch}>
      <Modal {...modalProps}  />
    </div>;

}


export function spawnDialogWindow( Modal, modalProps={} )  {
  dialogEvents.emit(  "pushModal",  { Modal, modalProps }  );
}

